import { render, staticRenderFns } from "./addInsurance.vue?vue&type=template&id=1148160c"
import script from "./addInsurance.vue?vue&type=script&lang=js"
export * from "./addInsurance.vue?vue&type=script&lang=js"
import style0 from "./addInsurance.vue?vue&type=style&index=0&id=1148160c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports